import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errorMessage } from "../lib/api";

// Handles the return from Emergent Google sign-in (#session_id=...)
export default function AuthCallback() {
  const { hash } = useLocation();
  const nav = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    api.post("/auth/google", { session_id: sessionId })
      .then(({ data }) => {
        localStorage.setItem("dec_admin_token", data.token);
        window.history.replaceState(null, "", "/admin/dashboard");
        nav("/admin/dashboard", { replace: true });
      })
      .catch((e) => setError(errorMessage(e)));
  }, [hash, nav]);

  return (
    <section className="bg-cream text-ink py-28 font-sans" data-testid="auth-callback">
      <div className="max-w-md mx-auto px-6 text-center">
        {error ? (
          <>
            <p className="font-display text-2xl" role="alert">Sign in didn't work</p>
            <p className="mt-3 text-slate">{error}</p>
            <a href="/admin" className="mt-6 inline-flex bg-teal text-paper rounded-full px-6 py-3" data-testid="auth-callback-retry">Back to sign in</a>
          </>
        ) : <p className="text-slate">Signing you in...</p>}
      </div>
    </section>
  );
}
